import { GetTripDetailsResponse } from '../../services';

export const getEditOperator = (data: GetTripDetailsResponse) => {
  if (data.lastEditedBy) {
    return [data.lastEditedBy.firstName, data.lastEditedBy.lastName]
      .filter(Boolean)
      .join(' ');
  } else if (data.editOperator) {
    return data.editOperator;
  }
  return;
};

export const getEditTime = (data: GetTripDetailsResponse) => {
  return data.lastEditedTime && new Date(data.lastEditedTime);
};
